module.exports = __webpack_public_path__ + "static/media/404.b9f39e06.png";